var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.14062 0.640625L1.5 2.28125L0.859375 1.64062L0.140625 2.35938L1.14062 3.35938L1.5 3.70312L1.85938 3.35938L3.85938 1.35938L3.14062 0.640625ZM5.5 1.5V2.5H12V1.5H5.5ZM3.14062 4.64062L1.5 6.28125L0.859375 5.64062L0.140625 6.35938L1.14062 7.35938L1.5 7.70312L1.85938 7.35938L3.85938 5.35938L3.14062 4.64062ZM5.5 5.5V6.5H12V5.5H5.5ZM3.14062 8.64062L1.5 10.2812L0.859375 9.64062L0.140625 10.3594L1.14062 11.3594L1.5 11.7031L1.85938 11.3594L3.85938 9.35938L3.14062 8.64062ZM5.5 9.5V10.5H12V9.5H5.5Z",
    fill: "#FAFBFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.a12df76580fd5b02e2f08af6e420cb98.svg";
export { ForwardRef as ReactComponent };